<template>
    <div id="app">
        <loading-bar v-show="loading" />
        <error-bar v-show="error.on" />
        <portal-target name="top" />
        <portal-target name="root" />
        <portal-target name="modal" />
        <router-view />
    </div>
</template>

<script>
import { authenticationState } from "@/mixins";
import { updateAuthenticationState } from "@/graphql/mutations";

export default {
    name: "App",
    mixins: [authenticationState],
    metaInfo: {
        title: "Dashboard",
        titleTemplate: "%s | Vector AI",
    },
    data() {
        return {
            loading: false,
            error: {
                on: false,
                message: null,
            },
        };
    },
    computed: {
        authenticationStateDarkMode() {
            return this.authenticationState
                ? this.authenticationState.darkMode
                : null;
        },
    },
    methods: {
        checkDarkMode() {
            if (this.authenticationStateDarkMode !== null) {
                return this.authenticationStateDarkMode;
            } else {
                return (
                    window.matchMedia &&
                    window.matchMedia("(prefers-color-scheme: dark)").matches
                );
            }
        },
        watchDarkMode() {
            if (!window.matchMedia) return;

            window
                .matchMedia("(prefers-color-scheme: dark)")
                .addListener(this.addDarkModeSelector);
        },
        addDarkModeSelector() {
            if (this.checkDarkMode()) {
                document.documentElement.classList.add("mode-dark");
            } else {
                document.documentElement.classList.remove("mode-dark");
            }
        },
        async toggleDarkMode() {
            this.loading = true;
            try {
                await this.$apollo.mutate({
                    mutation: updateAuthenticationState,
                    variables: {
                        darkMode: !this.checkDarkMode(),
                    },
                });

                this.addDarkModeSelector();
            } catch (error) {
                console.log(error);
            }
            this.loading = false;
        },
    },
    watch: {
        authenticationStateDarkMode: "addDarkModeSelector",
    },
    mounted() {
        this.addDarkModeSelector();
        this.watchDarkMode();

        const self = this;
        this.$root.$on("toggleDarkMode", function() {
            self.toggleDarkMode();
        });

        this.$root.$on("loading", (value) => {
            this.loading = value;
        });

        this.$root.$on("error", (message) => {
            this.error = {
                on: true,
                message,
            };

            const self = this;

            this.$toast.open({
                message,
                duration: 5000,
                type: "error",
                position: "top-right",
                onClose: function() {
                    self.error = { on: false, message: null };
                },
            });

            this.loading = false;
        });
    },
};
</script>

<style lang="scss">
.loading-bar {
    @apply h-1 fixed top-0 z-30 bg-success;
    animation: progressAnimationStrike infinite 1s;
}

.error-bar {
    @apply h-1 fixed top-0 z-30 bg-error;
    animation: progressAnimationStrike infinite 5s;
}

@keyframes progressAnimationStrike {
    from {
        width: 0;
    }
    to {
        width: 100%;
    }
}
</style>
